import {
  Component,
  OnInit
} from '@angular/core';

import {
  LazyLoadEvent
} from 'primeng/api';

import {
  ShortCourseOrderModel
} from 'src/app/core/ShortCourseOrderModel';

import {
  AdminService
} from 'src/app/services/admin/admin.service';
import { CourseService } from 'src/app/services/course/course.service';


@Component({
  selector: 'app-admin-short-course-orders',
  templateUrl: './admin-short-course-orders.component.html',
  styleUrl: './admin-short-course-orders.component.scss'
})
export class AdminShortCourseOrdersComponent
  implements OnInit {


  // ============================================================
  // ORDER LIST
  // ============================================================

  shortCourseOrders:
    ShortCourseOrderModel[] = [];


  totalRecords = 0;

  pageNo = 1;

  pageSize = 10;

  firstRecord = 0;

  isLoading = false;

  errorMessage = '';


  // ============================================================
  // REGISTRATION MODAL
  // ============================================================

  showRegistrationModal:
    boolean = false;


  selectedRegistration:
    any = null;


  selectedRegistrationOrder:
    ShortCourseOrderModel | null = null;

  //store   prefix
  orderReferencePrefix: string = '';

  constructor(
    private adminService: AdminService, private courseService: CourseService
  ) {
  }



  // ============================================================
  // INIT
  // ============================================================

  ngOnInit(): void {

    this.getShortCourseOrders();
    this.getOrderReferencePrefix();
  }


  //get prefix
  getOrderReferencePrefix(): void {

    this.courseService.GetReferencePrefix('SHORT_COURSE_ORDER')
      .subscribe({
        next: (prefix: string) => {
          this.orderReferencePrefix = prefix;
        },
        error: (error) => {
          console.error(
            'Error loading reference prefix',
            error
          );
        }
      });
  }


  // ============================================================
  // GET SHORT COURSE ORDERS
  // ============================================================

  getShortCourseOrders(): void {

    this.isLoading =
      true;

    this.errorMessage =
      '';


    this.adminService
      .getShortCourseOrderList(
        'GET_ALL',
        this.pageNo,
        this.pageSize
      )
      .subscribe({

        next: response => {

          this.shortCourseOrders =
            response?.records || [];


          this.totalRecords =
            response?.totalRecords || 0;


          this.isLoading =
            false;

        },


        error: error => {

          this.isLoading =
            false;


          this.shortCourseOrders =
            [];


          this.totalRecords =
            0;


          this.errorMessage =
            error?.error?.message ||
            'Unable to load short-course orders.';

        }

      });

  }



  // ============================================================
  // PAGE CHANGE
  // ============================================================

  onPageChange(
    event: LazyLoadEvent
  ): void {

    const first =
      event.first ?? 0;


    const rows =
      event.rows ??
      this.pageSize;


    this.firstRecord =
      first;


    this.pageSize =
      rows;


    this.pageNo =
      Math.floor(
        first / rows
      ) + 1;


    this.getShortCourseOrders();

  }



  // ============================================================
  // STUDENT NAME
  // ============================================================

  getStudentName(
    order: ShortCourseOrderModel
  ): string {

    const fullName = [

      order.studentGivenName,

      order.studentSingleName

    ]
      .filter(
        value =>
          !!value?.trim()
      )
      .join(' ');


    return fullName || '-';

  }



  // ============================================================
  // FORMAT COURSE DATE
  // ============================================================

  formatCourseDate(
    value:
      string |
      null |
      undefined
  ): string {

    if (!value) {

      return '-';

    }


    const parts =
      value
        .trim()
        .split(' ');


    const datePart =
      parts[0];


    const dateValues =
      datePart.split('/');


    if (
      dateValues.length !== 3
    ) {

      return value;

    }


    const day =
      Number(
        dateValues[0]
      );


    const month =
      Number(
        dateValues[1]
      );


    const year =
      Number(
        dateValues[2]
      );


    if (
      !day ||
      !month ||
      !year
    ) {

      return value;

    }


    const date =
      new Date(
        year,
        month - 1,
        day
      );


    if (
      isNaN(
        date.getTime()
      )
    ) {

      return value;

    }


    return date.toLocaleDateString(
      'en-AU',
      {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      }
    );

  }



  // ============================================================
  // CHECK REGISTRATION BODY
  // ============================================================

  hasRegistration(
    order: ShortCourseOrderModel
  ): boolean {

    const registrationBody =
      (order as any)
        ?.registrationBody;


    if (
      registrationBody === null ||
      registrationBody === undefined
    ) {

      return false;

    }


    // ==========================================================
    // OBJECT
    // ==========================================================

    if (
      typeof registrationBody ===
      'object'
    ) {

      return (
        Object.keys(
          registrationBody
        ).length > 0
      );

    }


    // ==========================================================
    // STRING
    // ==========================================================

    const value =
      registrationBody
        .toString()
        .trim();


    return (
      value !== '' &&
      value !== '{}' &&
      value !== 'null' &&
      value !== 'undefined'
    );

  }



  // ============================================================
  // VIEW REGISTRATION
  // ============================================================

  viewRegistration(
    order: ShortCourseOrderModel
  ): void {

    console.log(
      'Registration Order:',
      order
    );


    this.selectedRegistrationOrder =
      order;


    this.selectedRegistration =
      null;


    this.errorMessage =
      '';


    const registrationBody =
      (order as any)
        ?.registrationBody;


    if (!registrationBody) {

      this.errorMessage =
        'Registration details are not available for this order.';

      return;
    }


    try {

      // ========================================================
      // PARSE REGISTRATION BODY
      // ========================================================

      const parsedBody =
        typeof registrationBody ===
          'string'
          ? JSON.parse(
            registrationBody
          )
          : registrationBody;


      // ========================================================
      // QUALIFICATION CERTIFICATES
      // ========================================================

      const qualificationCertificates =
        Array.isArray(
          parsedBody
            ?.qualificationCertificates
        )
          ? parsedBody
            .qualificationCertificates
            .map(
              (
                certificate: any
              ) => {

                return {

                  fileName:
                    certificate?.fileName
                    ??
                    certificate?.name
                    ??
                    '',

                  fileUrl:
                    certificate?.fileUrl
                    ??
                    certificate?.url
                    ??
                    ''
                };
              }
            )
            .filter(
              (
                certificate: any
              ) =>
                !!certificate.fileUrl
            )
          : [];


      // ========================================================
      // ID DOCUMENTS
      // ========================================================

      const idDocuments =
        Array.isArray(
          parsedBody
            ?.idDocuments
        )
          ? parsedBody
            .idDocuments
            .map(
              (
                document: any
              ) => {

                return {

                  idType:
                    document?.idType
                    ??
                    '',

                  fileName:
                    document?.fileName
                    ??
                    document?.name
                    ??
                    '',

                  fileUrl:
                    document?.fileUrl
                    ??
                    document?.url
                    ??
                    ''
                };
              }
            )
            .filter(
              (
                document: any
              ) =>
                !!document.fileUrl
            )
          : [];


      // ========================================================
      // FINAL REGISTRATION VIEW MODEL
      // ========================================================

      this.selectedRegistration = {

        ...parsedBody,


        // Always fall back to the order data if the JSON body
        // does not contain one of these values.

        orderId:
          parsedBody?.orderId
          ??
          order.id,

        courseTitle:
          parsedBody?.courseTitle
          ??
          order.shortCourseTitle
          ??
          '',

        firstName:
          parsedBody?.firstName
          ??
          order.studentGivenName
          ??
          '',

        lastName:
          parsedBody?.lastName
          ??
          order.studentSingleName
          ??
          '',

        emailAddress:
          parsedBody?.emailAddress
          ??
          order.studentEmail
          ??
          '',


        qualificationCertificates:
          qualificationCertificates,

        idDocuments:
          idDocuments,


        submittedDate:
          parsedBody?.submittedDate
          ??
          parsedBody?.declarationDate
          ??
          order.createdDate
          ??
          null
      };


      this.showRegistrationModal =
        true;


      console.log(
        'Selected Registration:',
        this.selectedRegistration
      );

    }
    catch (error) {

      console.error(
        'Unable to parse registration body:',
        error
      );


      this.errorMessage =
        'Unable to open the registration details.';
    }
  }


  // ============================================================
  // REGISTRATION FULL NAME
  // ============================================================

  getRegistrationFullName(
    registration: any
  ): string {

    if (!registration) {
      return '-';
    }


    const fullName =
      `${registration?.firstName || ''} ${registration?.lastName || ''}`
        .trim();


    return fullName || '-';
  }


  // ============================================================
  // FORMAT ID TYPE
  // ============================================================

  formatRegistrationIdType(
    idType: string
  ): string {

    if (!idType) {
      return '-';
    }


    const idTypeMap:
      Record<string, string> = {

      DRIVER_LICENCE:
        'Driver Licence',

      PASSPORT:
        'Passport',

      PROOF_OF_AGE:
        'Proof of Age',

      OTHER:
        'Other'
    };


    return (
      idTypeMap[
      idType.toUpperCase()
      ]
      ??
      idType
        .replace(
          /_/g,
          ' '
        )
        .toLowerCase()
        .replace(
          /\b\w/g,
          character =>
            character.toUpperCase()
        )
    );
  }


  // ============================================================
  // IMAGE FILE
  // ============================================================

  isRegistrationImageFile(
    fileUrl: string
  ): boolean {

    if (!fileUrl) {
      return false;
    }


    const cleanUrl =
      fileUrl
        .split('?')[0]
        .toLowerCase();


    return (
      cleanUrl.endsWith('.jpg') ||
      cleanUrl.endsWith('.jpeg') ||
      cleanUrl.endsWith('.png') ||
      cleanUrl.endsWith('.webp')
    );
  }


  // ============================================================
  // PDF FILE
  // ============================================================

  isRegistrationPdfFile(
    fileUrl: string
  ): boolean {

    if (!fileUrl) {
      return false;
    }


    const cleanUrl =
      fileUrl
        .split('?')[0]
        .toLowerCase();


    return cleanUrl.endsWith(
      '.pdf'
    );
  }



  // ============================================================
  // CLOSE REGISTRATION MODAL
  // ============================================================

  closeRegistrationModal(): void {

    this.showRegistrationModal =
      false;


    this.selectedRegistration =
      null;


    this.selectedRegistrationOrder =
      null;

  }


  // ============================================================
  // FORMAT ID TYPE
  // ============================================================

  formatIdType(
    idType:
      string |
      null |
      undefined
  ): string {

    if (!idType) {

      return '-';

    }


    switch (
    idType.toUpperCase()
    ) {

      case 'DRIVER_LICENCE':

        return 'Driver Licence';


      case 'PASSPORT':

        return 'Passport';


      case 'PROOF_OF_AGE':

        return 'Proof of Age';


      case 'OTHER':

        return 'Other';


      default:

        return idType
          .replace(
            /_/g,
            ' '
          );

    }

  }



  // ============================================================
  // CHECK IMAGE FILE
  // ============================================================

  isImageFile(
    url:
      string |
      null |
      undefined
  ): boolean {

    if (!url) {

      return false;

    }


    const cleanUrl =
      url
        .split('?')[0]
        .toLowerCase();


    return (
      cleanUrl.endsWith(
        '.jpg'
      ) ||
      cleanUrl.endsWith(
        '.jpeg'
      ) ||
      cleanUrl.endsWith(
        '.png'
      ) ||
      cleanUrl.endsWith(
        '.webp'
      )
    );

  }



  // ============================================================
  // CHECK PDF FILE
  // ============================================================

  isPdfFile(
    url:
      string |
      null |
      undefined
  ): boolean {

    if (!url) {

      return false;

    }


    const cleanUrl =
      url
        .split('?')[0]
        .toLowerCase();


    return cleanUrl.endsWith(
      '.pdf'
    );

  }



  // ============================================================
  // GET DOCUMENT FILE NAME
  // ============================================================

  getDocumentFileName(
    url:
      string |
      null |
      undefined
  ): string {

    if (!url) {

      return 'Document';

    }


    try {

      const cleanUrl =
        url.split('?')[0];


      const sections =
        cleanUrl.split('/');


      return (
        decodeURIComponent(
          sections[
          sections.length - 1
          ]
        ) ||
        'Document'
      );

    }
    catch {

      return 'Document';

    }

  }

  // ============================================================
  // DOCUMENT IMAGE PREVIEW SETTINGS
  // ============================================================

  // IMPORTANT:
  // Angular cannot directly read .NET appsettings.json.
  //
  // Keep these values the same as your backend appsettings,
  // OR later return them from an API if you want one central config.

  documentPreviewSettings = {

    certificate: {
      width: 0,
      height: 300
    },

    identity: {
      width: 0,
      height: 100
    }

  };


  // ============================================================
  // GET DOCUMENT IMAGE STYLE
  // ============================================================

  getDocumentImageStyle(
    type: 'certificate' | 'identity'
  ): { [key: string]: string } {

    const settings =
      this.documentPreviewSettings[type];

    const width =
      settings?.width ?? 0;

    const height =
      settings?.height ?? 0;


    const style: { [key: string]: string } = {

      display: 'block',

      margin: '0',

      'object-fit': 'contain',

      // Position the image content
      // at the LEFT / TOP.
      'object-position': 'left top'
    };


    // ==========================================================
    // WIDTH > 0
    // HEIGHT > 0
    //
    // Fixed preview box.
    // Image maintains its aspect ratio using object-fit.
    // ==========================================================

    if (
      width > 0 &&
      height > 0
    ) {
      style['width'] =
        `${width}px`;

      style['height'] =
        `${height}px`;

      style['max-width'] =
        '100%';

      return style;
    }


    // ==========================================================
    // WIDTH > 0
    // HEIGHT = 0
    //
    // Width is fixed.
    // Height calculated automatically.
    // ==========================================================

    if (
      width > 0 &&
      height <= 0
    ) {
      style['width'] =
        `${width}px`;

      style['height'] =
        'auto';

      style['max-width'] =
        '100%';

      return style;
    }


    // ==========================================================
    // WIDTH = 0
    // HEIGHT > 0
    //
    // Height is fixed.
    // Width calculated automatically.
    // ==========================================================

    if (
      width <= 0 &&
      height > 0
    ) {
      style['width'] =
        'auto';

      style['height'] =
        `${height}px`;

      style['max-width'] =
        '100%';

      return style;
    }


    // ==========================================================
    // WIDTH = 0
    // HEIGHT = 0
    //
    // Use available width.
    // Height automatically follows aspect ratio.
    // ==========================================================

    style['width'] =
      '100%';

    style['height'] =
      'auto';

    style['max-width'] =
      '100%';


    return style;
  }



  isSignatureImage(
    signature: string | null | undefined
  ): boolean {

    if (!signature) {
      return false;
    }

    return (
      signature.startsWith('data:image/') ||
      signature.startsWith('http://') ||
      signature.startsWith('https://')
    );

  }



  
// ============================================================
// PAGINATION
// ============================================================

// Total number of pages
get totalPages(): number {

  return Math.max(
    1,
    Math.ceil(
      this.totalRecords / this.pageSize
    )
  );

}


// Generate page numbers
get pageNumbers(): number[] {

  return Array.from(
    { length: this.totalPages },
    (_, index) => index + 1
  );

}


// First displayed record
get startRecord(): number {

  if (this.totalRecords === 0) {
    return 0;
  }

  return this.firstRecord + 1;

}


// Last displayed record
get endRecord(): number {

  if (this.totalRecords === 0) {
    return 0;
  }

  return Math.min(
    this.firstRecord + this.shortCourseOrders.length,
    this.totalRecords
  );

}


// Change page
changePage(page: number): void {

  if (
    !Number.isInteger(page) ||
    page < 1 ||
    page > this.totalPages ||
    this.isLoading
  ) {
    return;
  }

  if (this.pageNo === page) {
    return;
  }

  this.pageNo = page;

  this.firstRecord =
    (this.pageNo - 1) * this.pageSize;

  this.getShortCourseOrders();

}


// Previous page
previousPage(): void {

  this.changePage(
    this.pageNo - 1
  );

}


// Next page
nextPage(): void {

  this.changePage(
    this.pageNo + 1
  );

}


// Rows per page change
onPageSizeChange(): void {

  this.pageNo = 1;

  this.firstRecord = 0;

  this.getShortCourseOrders();

}

}